export default {
  translation: {
    /*Header*/
    home: "Home",
    contact: "Contact Us",
    store: "Store",

    /*Event List*/
    home2: "HOME",
    sidebar: "WITHOUT SIDEBAR",
    date: "MARCH 4, 2020",
    title: "APEX LEGENDS YEARLY TOURNAMENT IS HERE!!!",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry." +
      " Lorem Ipsum has been the industry's standard dummy text ever since the 1500s," +
      " when an unknown printer took a galley of type and scrambled it to make a type specimen book." +
      " It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged",
    more: "More Details",

    /*Event Details*/
    /*event specifics*/
    prizePool: "PRIZE POOL",
    playModel: "PLAY MODEL",
    platform: "PLATFORM",
    player: "PLAYER",
    gameDay: "August 25, 2020",
    gamePlayers: "4 GROUPS",
    /*tournament*/
    about: "ABOUT THE TOURNAMENT",

    /* Tournament Bracket */
    tournamentRound: {
      round1: "Round 1",
      round2: "Round 2",
      round3: "Round 3",
      semi: "west semifinals",
      east: "easT semifinals",
      final: "Championship",
    },

    /*tournament details*/
    tournamentDetails: {
      meeting: "Meet The Players",
    },

    /*Contact*/
    contactHeader: "Drop a line if you're interested in joining",
    contactSubHeader: "Get In Touch",
    placeholder: {
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      message: "Your Message",
    },
    sendButton: "SEND",

    /*Store*/
    storeItemPrice: "$50.00",
    itemNames: {
      fifa: "FIFA",
      cod: "CALL OF DUTY",
      nba: "NBA",
      mk: "MORTAL KOMBAT 11",
    },
    itemDescription: {
      fifa:
        'FIFA stands for "Fédération Internationale de Football Association" and is the international federation governing association football (to distinguish it from "union football", i.e. rugby).',
      cod: 'a first-person shooter, Call of Duty places the player in control of an infantry soldier who makes use of various authentic World War II firearms in combat.',
      nba: 'The NBA\'s analytics revolution (insert Revenge of the Nerds joke here) has changed the way we think and talk about basketball.',
      mk: '"Mortal Kombat." In gaming, MK refers to the "Mortal Kombat" video game franchise, originally developed by Midway Games in 1992.',
    },

    /*Footer*/
    copyright: "© E Gamerz 2020 . All Rights Reserved",
    // socials: {
    //   facebook: "Facebook",
    //   twitter: "Twitter",
    //   instagram: "Instagram",
    // },
  },
};
